import { Field, FieldValidatorType } from 'scripts/type'

export default function getFieldIsRequired(field: Field) {
  return !!field.validators?.find((v) => v.type === FieldValidatorType.Presence)
}
